const readEnv = (key) => (process.env[key] || "").trim();
const FALLBACK_CONTACT_URL = "/contact";
const FALLBACK_BOOKING_URL = "/book";

export const PHONE_NUMBER = readEnv("REACT_APP_PHONE_NUMBER") || "07513660154";
export const PHONE_TEL = readEnv("REACT_APP_PHONE_TEL") || "tel:+447513660154";

const defaultWhatsAppUrl = (() => {
  const telDigits = PHONE_TEL.replace(/^tel:/, "").replace(/[^0-9]/g, "");
  if (!telDigits) {
    return FALLBACK_CONTACT_URL;
  }
  return `https://wa.me/${telDigits}`;
})();

export const BOOKING_URL = readEnv("REACT_APP_BOOKING_URL") || FALLBACK_BOOKING_URL;
export const WHATSAPP_URL = readEnv("REACT_APP_WHATSAPP_URL") || defaultWhatsAppUrl;
export const LIVE_CHAT_URL = readEnv("REACT_APP_LIVE_CHAT_URL") || FALLBACK_CONTACT_URL;

export const CONTACT_EMAIL = readEnv("REACT_APP_CONTACT_EMAIL") || "info@specialistdentallondon.co.uk";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
export const CLINIC_ADDRESS_LINE_1 =
  readEnv("REACT_APP_CLINIC_ADDRESS_LINE_1") || "157 High St, New Malden KT3 4BH";
export const CLINIC_ADDRESS_LINE_2 =
  readEnv("REACT_APP_CLINIC_ADDRESS_LINE_2") || "Located inside The Health Hub";
